<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';
  import Track from '@utils/track';

  const dispatch = createEventDispatcher();

  let handleNext = () => {
    Track.joiningScreenNext();
    dispatch('finished');
  };
</script>

<style style="text/scss" lang="scss">
  @import '../../../vendor/design-system.scss';

  .invite-flow-welcome-container {
    margin: -30px;
    margin-top: -50px;
  }

  .invite-flow-banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin-bottom: 32px;
  }

  .invite-flow-welcome-modal-content {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 32px;
    padding: 0 20px;
  }

  .invite-flow-welcome-modal-title {
    font-size: 42px;
    line-height: 38px;
    font-weight: 800;
    text-transform: uppercase;
    color: #717171;
  }
  
</style>

<div class="invite-flow-welcome-container">
  <img src="/images/app-invites/invite-flow-banner-01.png" class="invite-flow-banner-image" />
  <div class="invite-flow-welcome-modal-content">
    <div class="invite-flow-welcome-modal-title ui-title national-2-narrow">Join 100k+ Creators</div>
      <Button
        class="test-success-next-btn"
        text="Next"
        on:click={handleNext} />
  </div>
</div>